import { render, staticRenderFns } from "./RenameMembershipDialog.vue?vue&type=template&id=ff83d7de"
import script from "./RenameMembershipDialog.vue?vue&type=script&lang=js"
export * from "./RenameMembershipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports